// extracted by mini-css-extract-plugin
export var quillEditor = "_nm-1";
export var variable = "_nm-0";